import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/location_new/houston/banner_hosuton.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner hosuton_banner no-bread-loc-banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Houston">
                <h1>
                  Mobile App Developers in Houston
                </h1>
              </div>
              <p className="main_para">
                Are you ready to revolutionize your business with novel mobile
                applications? Look no further than TekRevol, your trusted
                associate for mobile application development in Houston, Texas.
                Our experienced app developers in Houston will help you convert
                your app ideas into reality. From conceptualizing your idea to
                designing its interface and the core development of
                feature-packed functionalities, we build your app with next-gen
                technologies.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
